export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_FAILED_ACTION = 'SET_FAILED_ACTION';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const SET_TRANSLATE_LANGUAGE_CONTENT = 'SET_TRANSLATE_LANGUAGE_CONTENT';

export const setMessage = message => ({
  type: SET_MESSAGE,
  message: message
});

export const setMessageForFailedAction = failedAction => ({
  type: SET_FAILED_ACTION,
  failedAction
});

export const clearMessage = () => ({
  type: CLEAR_MESSAGE
});

export const setTranslateLanguageContent = translateLanguageContent => ({
  type: SET_TRANSLATE_LANGUAGE_CONTENT,
  translateLanguageContent
});